/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_SubtitleInputs */

const en_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free. Upgrade when you need more power. Cancel anytime.`)
};

const de_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos starten. Upgraden, wenn du mehr Leistung benötigst. Jederzeit kündbar.`)
};

const fr_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commence gratuitement. Passe à un plan supérieur quand tu as besoin de plus. Annule à tout moment.`)
};

const es_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empiece gratis. Mejore su plan cuando necesite más potencia. Cancele en cualquier momento.`)
};

const it_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia gratis. Aggiorna quando hai bisogno di più potenza. Annulla in qualsiasi momento.`)
};

const nl_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start gratis. Upgrade wanneer je meer kracht nodig hebt. Annuleer op elk moment.`)
};

const pl_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij za darmo. Ulepszaj, gdy potrzebujesz więcej mocy. Anuluj w dowolnym momencie.`)
};

const fi_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita ilmaiseksi. Päivitä, kun tarvitset enemmän voimaa. Peruuta milloin tahansa.`)
};

const da_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start gratis. Opgrader når du har brug for mere kraft. Opsig når som helst.`)
};

const sv_pricing_subtitle = /** @type {(inputs: Pricing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Börja gratis. Uppgradera när du behöver mer kraft. Avbryt när som helst.`)
};

/**
* | output |
* | --- |
* | "Start free. Upgrade when you need more power. Cancel anytime." |
*
* @param {Pricing_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_subtitle = /** @type {((inputs?: Pricing_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_subtitle(inputs)
	if (locale === "fr") return fr_pricing_subtitle(inputs)
	if (locale === "es") return es_pricing_subtitle(inputs)
	if (locale === "it") return it_pricing_subtitle(inputs)
	if (locale === "nl") return nl_pricing_subtitle(inputs)
	if (locale === "pl") return pl_pricing_subtitle(inputs)
	if (locale === "fi") return fi_pricing_subtitle(inputs)
	if (locale === "da") return da_pricing_subtitle(inputs)
	if (locale === "sv") return sv_pricing_subtitle(inputs)
	return en_pricing_subtitle(inputs)
});